module.exports = __webpack_public_path__ + "static/media/header-samplings.7adc483f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/samplings/header-samplings.png
// module id = 700
// module chunks = 0